import { baseApi } from "./base.api";

export const districtsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchDistricts: build.query({
      query: (params) => ({ url: "/districts/fetch", method: "GET", params }),
      providesTags: ["District"],
    }),
    fetchAllDistricts: build.query({
      query: () => ({ url: "/districts/fetch/all", method: "GET" }),
      providesTags: ["District"],
    }),
    fetchTrashedDistricts: build.query({
      query: (params) => ({ url: "/districts/fetch/trashed", method: "GET", params }),
      providesTags: ["District"],
    }),
    fetchDistrictById: build.query({
      query: (id) => ({ url: `/districts/fetch/${id}`, method: "GET" }),
      providesTags: ["District"],
    }),
    createDistrict: build.mutation({
      query: (body) => ({ url: "/districts/create", method: "POST", body }),
      invalidatesTags: ["District", "Permission"],
    }),
    updateDistrict: build.mutation({
      query: ({ id, body }) => ({ url: `/districts/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["District", "Permission"],
    }),
    restoreDistrict: build.mutation({
      query: (id) => ({ url: `/districts/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["District"],
    }),
    bulkRestoreDistricts: build.mutation({
      query: (body) => ({ url: "/districts/bulk-restore", method: "POST", body }),
      invalidatesTags: ["District"],
    }),
    deleteDistrict: build.mutation({
      query: (id) => ({ url: `/districts/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["District"],
    }),
    bulkDeleteDistricts: build.mutation({
      query: (body) => ({ url: "/districts/bulk-delete", method: "POST", body }),
      invalidatesTags: ["District"],
    }),
    destroyDistrict: build.mutation({
      query: (id) => ({ url: `/districts/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["District"],
    }),
    bulkDestroyDistricts: build.mutation({
      query: (body) => ({ url: "/districts/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["District"],
    }),
  }),
});

export const {
  useFetchDistrictsQuery,
  useFetchAllDistrictsQuery,
  useFetchTrashedDistrictsQuery,
  useFetchDistrictByIdQuery,
  useCreateDistrictMutation,
  useUpdateDistrictMutation,
  useRestoreDistrictMutation,
  useBulkRestoreDistrictsMutation,
  useDeleteDistrictMutation,
  useBulkDeleteDistrictsMutation,
  useDestroyDistrictMutation,
  useBulkDestroyDistrictsMutation,
} = districtsApi;
